import Icon from '../components/Icon.vue'

Icon.register({
  'money-bill-wave-alt': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M621.2 54.5C582.4 38.2 543.5 32 504.8 32 381.6 32 258.4 94.3 135.3 94.3 104.4 94.3 73.5 90.4 42.6 80.6 39.1 79.5 35.6 79 32.3 79 15 79 0 92.3 0 110.8V428.1C0 440.7 7.2 452.7 18.8 457.5 57.6 473.8 96.5 480 135.3 480 258.4 480 381.6 417.6 504.8 417.6 535.6 417.6 566.5 421.6 597.4 431.4 600.9 432.5 604.4 433 607.8 433 625 433 640 419.7 640 401.2V83.9C640 71.3 632.8 59.3 621.2 54.5zM320 352C275.8 352 240 309 240 256 240 203 275.8 160 320 160S400 203 400 256C400 309 364.2 352 320 352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/money-bill-wave-alt.js
// module id = n8Xn
// module chunks = 144